import { fg } from '@atlaskit/platform-feature-flags/fg';

export const AGENT_SESSIONS_PAGE_SIZE = 25;
export const AGENT_SESSIONS_SORT = 'lastStateChangeAt DESC';
export const UNSEEN_WINDOW_MS: number = 72 * 60 * 60 * 1000;

type Policy = Readonly<{ includeLocalAgentSessions: boolean }>;
let pagePolicy: Policy | undefined;

export const getAgentSessionsPolicy = (): Policy => {
	const read = (): Policy => ({
		includeLocalAgentSessions: fg('rovo_chat_all_chats_local_agent_sessions'),
	});
	// Server requests must not share a user's gate evaluation.
	if (typeof window === 'undefined') return read();
	return (pagePolicy ??= read());
};

export const escapeAgentSessionAqlLiteral = (value: string): string =>
	value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
